import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { push } from "connected-react-router";
import { PROYECT, api_get, api_post } from "services/api";
import { orderArray } from "helpers/orderArray";
import { normalizedArray } from "helpers/normalizedArray";
import { setSnackbar } from "redux/actions/search/searchActions";

// giotanks
const LOAD_GIOTANKS_GIOTANKS = "LOAD_GIOTANKS_GIOTANKS";
const SET_GIOTANKS_GIOTANKS = "SET_GIOTANKS_GIOTANKS";
const ERROR_GIOTANKS_GIOTANKS = "ERROR_GIOTANKS_GIOTANKS";

// new giotank (create/assign)
const SEND_NEW_GIOTANK = "SEND_NEW_GIOTANK";
const SUCCESS_NEW_GIOTANK = "SUCCESS_NEW_GIOTANK";
const ERROR_NEW_GIOTANK = "ERROR_NEW_GIOTANK";

// filters
const HANDLE_INPUTS_GIOTANKS = "HANDLE_INPUTS_GIOTANKS";

// general
const CLEAR_ERROR_GIOTANKS = "CLEAR_ERROR_GIOTANKS";
const SET_ERROR_GIOTANKS = "SET_ERROR_GIOTANKS";

const INITIAL_STATE = {
  giotanks: [],
  accounts: [],
  isLoading: false,
  error: false,
  message: "",
  errorMessage: "",
  isLoadingGiotanks: false,
  // filters
  station: [],
};

const giotanksReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    // giotanks
    case LOAD_GIOTANKS_GIOTANKS:
      return {
        ...state,
        giotanks: [],
        accounts: [],
        isLoadingGiotanks: true,
      };
    case SET_GIOTANKS_GIOTANKS:
      return {
        ...state,
        giotanks: payload.giotanks,
        accounts: payload.accounts,
        isLoadingGiotanks: false,
      };
    case ERROR_GIOTANKS_GIOTANKS:
      return {
        ...state,
        isLoadingGiotanks: false,
      };
    // new giotank (create/assign)
    case SEND_NEW_GIOTANK:
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: "",
        message: "",
      };
    case SUCCESS_NEW_GIOTANK:
      return {
        ...state,
        isLoading: false,
        message: payload,
      };
    case ERROR_NEW_GIOTANK:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: payload.message,
      };
    // filter
    case HANDLE_INPUTS_GIOTANKS:
      return {
        ...state,
        [payload.key]: payload.value,
      };

    // error
    case CLEAR_ERROR_GIOTANKS:
      return {
        ...state,
        error: false,
        errorMessage: "",
      };
    case SET_ERROR_GIOTANKS:
      return {
        ...state,
        error: true,
        errorMessage: payload,
      };

    default:
      return state;
  }
};

// Actions
function getGiotanks(stations) {
  return {
    type: LOAD_GIOTANKS_GIOTANKS,
    payload: { stations },
  };
}
function handleGiotanksInputs(key, value) {
  return {
    type: HANDLE_INPUTS_GIOTANKS,
    payload: { key, value },
  };
}
function sendNewGiotank(body, onSuccess = null) {
  return { type: SEND_NEW_GIOTANK, body, onSuccess };
}
function setError(error) {
  return {
    type: SET_ERROR_GIOTANKS,
    payload: error,
  };
}
function clearError() {
  return {
    type: CLEAR_ERROR_GIOTANKS,
  };
}

// sagas
function* fetchGiotanks(action) {
  const {
    payload: { stations = [] },
  } = action;
  const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}`;
  const urlStations = stations.map((station) => `stations=${station.value}`).join("&");

  try {
    const [giotanks, accounts] = yield all([
      call(api_get, `${baseUrl}/giotanks?${urlStations}`),
      call(api_get, `${baseUrl}/accounts?${urlStations}`),
    ]);
    const accountsConfig = {
      keyValue: "id",
      keyLabel: "code",
      keySecondLabel: "alias",
    };

    yield put({
      type: SET_GIOTANKS_GIOTANKS,
      payload: {
        giotanks,
        accounts: normalizedArray(orderArray(accounts, "code"), accountsConfig, true),
      },
    });
  } catch (message) {
    yield put({ type: ERROR_GIOTANKS_GIOTANKS });
    yield put(setSnackbar(message));
  }
}

function* sendForm(action) {
  const { body, onSuccess } = action;
  const url = `${process.env.REACT_APP_URL}${PROYECT}/giotanks`;
  try {
    yield call(api_post, url, body);

    yield put({
      type: SUCCESS_NEW_GIOTANK,
      payload: "Guardado con éxito",
    });
    yield put(setSnackbar("Guardado con éxito", "success"));
    // Se recarga la tabla con las plantas filtradas: las filas tienen forma
    // { giotank, customer } y la respuesta del POST no la garantiza
    const station = yield select((state) => state.giotanks.station);
    if (station?.length) yield put(getGiotanks(station));
    if (onSuccess) {
      onSuccess();
    } else {
      yield put(push("/admin/giotanks"));
    }
  } catch (message) {
    yield put({
      type: ERROR_NEW_GIOTANK,
      payload: {
        message,
      },
    });
  }
}

function* giotanksSaga() {
  yield takeLatest(LOAD_GIOTANKS_GIOTANKS, fetchGiotanks);
  yield takeLatest(SEND_NEW_GIOTANK, sendForm);
}

export {
  // reducer
  giotanksReducer,
  // actions
  getGiotanks,
  sendNewGiotank,
  // filters
  handleGiotanksInputs,
  // error
  setError,
  clearError,
  // saga
  giotanksSaga,
};
